<template>
   
</template>

<script lang="ts">
export default defineComponent({ 
    created(){
        // 以下内容永远不会被打印，因为访问此页时会被中间件生定向 
        if (import.meta.client){
            console.log('[created()] 正在访问 niuniuGame');
        }
    },
});
</script>
